import { Shark, SmartModel, Utils } from "shark-mvc";
import moment from "moment";
import provinceList from "../data/province-list";
import Client from "./Client";

class Visit extends SmartModel {
	constructor(data) {
		super();

		this.activityStatus = 1;
		this.address = "";
		this.agentGuid = "";
		this.buyers = "";
		this.city = "";

		this.cliName = ""; //Join field
		this.cliProvince = ""; //Join field
		this.cliSector = ""; //Join field

		this.clientGuid = "";
		this.clientName = "";
		this.constructionCompanies = "";
		this.constructionSiteCardCount = 0;
		this.constructionSiteClosedCount = 0;
		this.constructionSiteCount = 0;
		this.constructionSiteData = {
			address: "",
			city: "",
			logisticNotes: "",
			name: "",
			possibleAggressionsAndInteractions: "",
			premiseDestination: "",
			province: "",
			region: "",
			subAgent: "",
			personInCharge: {
				name: "",
				eMail: "",
				phone: ""
			},
			useRegisteredOffice: false,
			zip: ""
		},
		this.constructionSitePendingCount = 0;
		this.contactExtraData = {}; //Campo join
		this.contact = {}; //Join Object
		this.contactName = "";
		this.contactSource = 0;
		this.createdAt = "0000-00-00 00:00:00";
		this.createdByGuid = "";
		this.designers = "";
		this.email = "";
		this.expiredAppointmentCount = 0;
		this.extraData = {
			activityStatusId: 1, //1: in attesa, 2: compilato scheda informativa, ...poi preventivi
			activityStatus: "",
			interestSolutions: [],
			isNewContact: false,
			leadGuid: "",
			overallStatus: 0,
			providedSpecifications: false,
			quotations: [], //{guid: "", status: 0}
			relatedGuids: {
				clientGuid: "",
			},
			roles: {
				customer: false,
				designer: false,
				endUser: false,
			},
			sourceFair: "",
			userHistory: [],
		};
		this.futureContactDate = "0000-00-00 00:00:00";
		this.futureContactEvent = { guid: ""};
		this.guid = "";
		this.isFromLead = false;
		this.lastFUDate = ""; //Join field
		this.latestFollowUp = "";
		this.mineViewedFollowUp = 0;
		this.newFollowUpCount = 0;
		this.nextAppointment = "";
		this.nextAppointmentDate = ""; //Join field
		this.notes = "";
		this.notInterestedReason = "";//Dave: da gestire ovunque il cambio di questo campo con outcomeNote
		this.offerStatus = 0;
		this.outcome = "";
		this.outcomeNote = "";
		this.phone = "";
		this.prospectName = "";
		this.prospectSector = "";
		this.province = "";
		this.quotationAcceptedCount = 0;
		this.quotationPendingCount = 0;
		this.quotationRefusedCount = 0;
		this.reason = "";
		this.referenceDate = "0000-00-00 00:00:00";
		this.region = "";
		this.role = "";
		this.sentDocumentsGuids = [];
		this.siteInfoSheetCount = 0;
		this.status = 0;
		this.totalFollowUpCount = 0;
		this.updatedAt = "0000-00-00 00:00:00";
		this.updatedByGuid = "";
		this.zip = "";

		this.__agentFullName = "";
		this.__contactSourceLabel = "";
		this.__errors = {};
		this.__errorsCount = 0;
		this.__followUpCount = 0;
		this.__followUpList = [];
		this.__futureContactDate = "";
		this.__futureContactDateLabel = "";
		this.__hasFollowUp = false;
		this.__hasNewFollowUp = false;
		this.__isValid = true;
		this.__leadGuid = "";
		this.__nextActivityLabel = "";
		this.__notesHtml = "";
		this.__outcomeLabel = "";
		this.__quotationAcceptedCount = 0;
		this.__quotationRefusedCount = 0;
		this.__referenceDate = "";
		this.__referenceDateLabel = "";
		this.__render = false;
		this.__renderActivityStatusAsLink = false;
		this.__reportData = {
			province: "",
			statusId: 0
		};
		this.__showOutcomeInStatus = false;
		this.__showFutureContactDate = false;
		// this.__showNotInterestedReasonBox = false;
		this.__sourceAppointmentGuid = "";
		this.__statusLabel = "";
		this.__statusForFilter = "";
		this.__statusForFilterCSSClass = "";

		if (data) {
			this.import(data);
		}
	}

	export () {
		var exportData = this.__export();

		exportData.constructionSiteData = JSON.stringify(this.constructionSiteData);
		exportData.extraData = JSON.stringify(this.extraData);
		exportData.isFromLead = this.isFromLead ? 1 : 0;
		exportData.sentDocumentsGuids = JSON.stringify(this.sentDocumentsGuids);
		exportData.futureContactDate = this.futureContactDate._isValid ? this.futureContactDate.utc().format("YYYY-MM-DD HH:mm:ss") : "0000-00-00 00:00:00";
		exportData.futureContactEvent = JSON.stringify(this.futureContactEvent);
		exportData.referenceDate = this.referenceDate._isValid ? this.referenceDate.utc().format("YYYY-MM-DD HH:mm:ss") : "0000-00-00 00:00:00";

		return exportData;
	}

	import (data, options) {
		this.__import(data, options);

		this.importNumberField("constructionSiteCardCount", data.constructionSiteCardCount);

		if (this.importDateField("createdAt", data.createdAt)) {
			this.__createdAt = this.createdAt.isValid() ? this.createdAt.format("YYYY-MM-DD") : "";
			this.__createdAtLabel = this.createdAt.isValid() ? this.createdAt.format("DD/MM/YYYY") : "";
		}

		if (this.importDateField("lastFUDate", data.lastFUDate)) {
			this.__lastFUDate = this.lastFUDate.format("YYYY-MM-DD");
			this.__lastFUDateLabel = this.lastFUDate.format("DD/MM/YYYY");
		}

		if (this.importDateField("nextAppointmentDate", data.nextAppointmentDate)) {
			this.__nextAppointmentDate = this.nextAppointmentDate.format("YYYY-MM-DD");
			this.__nextAppointmentDateLabel = this.nextAppointmentDate.format("DD/MM/YYYY");
		}

		//Dave: Questa cosa non dovrebbe più servire visto che gestiamo activityStatus a monte.
		// if (data.extraData && data.extraData !== "") {
		// 	if (isNaN(parseInt(this.extraData.activityStatusId))) {
		// 		this.extraData.activityStatusId = 0;
		// 	}
		// 	else {
		// 		this.extraData.activityStatusId = parseInt(this.extraData.activityStatusId);
		// 	}
			
		// 	switch (this.extraData.activityStatusId) {
		// 		case 2:
		// 			this.extraData.activityStatus = "Compilata scheda informativa";
		// 			this.__renderActivityStatusAsLink = true;
		// 			break;
		// 	}
		// }
		if (this.extraData.isNewContact === undefined) {
			this.extraData.isNewContact = false;
		}

		if (data.futureContactDate !== undefined) {
			this.futureContactDate = moment.utc(data.futureContactDate).local();
			if (this.futureContactDate._isValid) {
				this.__futureContactDate = this.futureContactDate.format("YYYY-MM-DD");
				this.__futureContactDateLabel = this.futureContactDate._isValid ? this.futureContactDate.format("DD/MM/YYYY") : "";
			}
			this.futureContactEvent = Utils.parseJSON(data.futureContactEvent, "object");
		}

		const agentList = Shark.get("agentList");
		if (agentList && agentList.length > 0) {
			const visitAgent = Utils.safp(agentList, "guid", this.agentGuid);

			if (visitAgent) {
				this.__agentFullName = visitAgent.__fullName;
			}
		}
		
		this.importNumberField("contactSource", data.contactSource);
		const contactSourceMap = Shark.get("contactSourceMap");
		this.__contactSourceLabel = contactSourceMap[this.contactSource];

		if (data.isFromLead !== undefined) {
			this.isFromLead = parseInt(data.isFromLead) === 1 || data.isFromLead === true;
		}

		this.importNumberField("activityStatus", data.activityStatus);
		this.importNumberField("constructionSiteClosedCount", data.constructionSiteClosedCount);
		this.importNumberField("constructionSitePendingCount", data.constructionSitePendingCount);
		this.importNumberField("expiredAppointmentCount", data.expiredAppointmentCount);
		
		// this.importNumberField("mineViewedFollowUp", data.mineViewedFollowUp); //??
		this.importNumberField("newFollowUpCount", data.newFollowUpCount);

		this.importNumberField("quotationAcceptedCount", data.quotationAcceptedCount);
		this.importNumberField("quotationPendingCount", data.quotationPendingCount);
		this.importNumberField("quotationRefusedCount", data.quotationRefusedCount);
		this.importNumberField("quotationSentCount", data.quotationSentCount);
		this.importNumberField("siteInfoSheetCount", data.siteInfoSheetCount);
		this.importNumberField("status", data.status);
		// this.importNumberField("totalFollowUpCount", data.totalFollowUpCount); //??

		if (this.importDateField("updatedAt", data.updatedAt)) {
			this.__updatedAt = this.updatedAt.format("YYYY-MM-DD");
			this.__updatedAtLabel = this.updatedAt.format("DD/MM/YYYY - HH:mm");
		}

		const visitOutcomeMap = Shark.get("visitOutcomeMap");
		const reportStatusMap = Shark.get("reportStatusMap");

		//1: Da sviluppare, 2: In gestione, 3: Concluso Ok, 4: Concluso KO, 5: non interessato, 6: non raggiungibile
		//DAve: Tutta la roba dopo si dovrebbe poter sostituire con questa:
		if (this.activityStatus > 0) {
			this.__statusLabel = reportStatusMap[this.activityStatus];

			switch (this.activityStatus) {
				case 1:
					this.__statusForFilter = "develop";
					this.__statusForFilterCSSClass = "visit-status-develop";
					break;
				case 2:
					this.__statusForFilter = "managing";
					this.__statusForFilterCSSClass = "visit-status-managing";
					this.__status_managing = true;
					break;
				case 3:
					this.__statusForFilter = "concludedOk";
					this.__statusForFilterCSSClass = "visit-status-concluded visit-status-concluded-ok";
					break;
				case 4:
					this.__statusForFilter = "concludedKo";
					this.__statusForFilterCSSClass = "visit-status-concluded visit-status-concluded-ko";
					break;
				case 5:
					this.__statusForFilter = "not-interested";
					this.__statusForFilterCSSClass = "visit-status-not-interested";
					break;
				case 6:
					this.__statusForFilter = "not-reachable";
					this.__statusForFilterCSSClass = "visit-status-not-reachable";
					break;
			}
		}
		//Usa le map per le eteichette
		this.__outcomeLabel = visitOutcomeMap[this.outcome];
		switch (this.outcome) {
			case "future_v":
			case "future_p":
				if (this.activityStatus !== 2) {
					//DAve.Warn: Non sono convinto che questo robo qui sotto sia corretto: se ho l'appuntamento futuro lo devo mostrare cmq (ora "__showFutureContactDate" viene usato per mostrare il campo data nell'edit)
					this.__showFutureContactDate = true;
					this.__reportData.statusId = 0;
				}
				break;
			case "1":
				this.__showOutcomeInStatus = false;
				this.__reportData.statusId = 0;
				break;
			case "5"://"Non interessato";
				this.__showOutcomeInStatus = false;
				this.__reportData.statusId = 2;
				break;
			case "6"://"Non raggiungibile";
				this.__showOutcomeInStatus = false;
				this.__reportData.statusId = 1;
				break;
		}

		if (this.outcome === "1" && this.extraData.activityStatusId <= 1) {
			this.__nextActivityLabel = "";
		}

		this.__reportData.province = this.province;
		
		if (data.referenceDate !== undefined) {
			this.referenceDate = moment.utc(data.referenceDate).local();
			if (this.referenceDate._isValid) {
				this.__referenceDate = this.referenceDate.format("YYYY-MM-DD");
				this.__referenceDateLabel = this.referenceDate.format("DD/MM/YYYY");
			}
		}

		this.parseFollowUps();

		this.__notesHtml = this.notes.replace(/\n/g, "<br>");

		this.__rolesLabel = "";
		if (this.extraData.roles.customer) {
			this.__rolesLabel += ", Committente";
		}
		if (this.extraData.roles.designer) {
			this.__rolesLabel += ", Progettista";
		}
		if (this.extraData.roles.endUser) {
			this.__rolesLabel += ", Utilizzatore finale";
		}

		if (this.__rolesLabel !== "") {
			this.__rolesLabel = this.__rolesLabel.substr(2);
		}
		else {
			this.__rolesLabel = "<small>(ruolo non impostato)</small>";
		}

		// this.__showNotInterestedReasonBox = this.outcome == "5" || this.outcome == "1" && this.isFromLead;

		if (this.extraData.isNewContact) {
			this.__contactOriginLabel = "Prospect";
			this.__contactOriginCSSClass = "client-type-visit";
		}
		else if (this.isFromLead) {
			this.__contactOriginLabel = "Lead assegnato";
			this.__contactOriginCSSClass = "client-type-lead";
		}
		else if (!this.extraData.isNewContact && !this.isFromLead) {
			this.__contactOriginLabel = "Cliente";
			this.__contactOriginCSSClass = "client-type-client";
		}
		this.parseNextAppointment();

		if (data.contact) {
			this.contact = new Client(data.contact);
		}

		if (this.extraData.interestSolutions) {
			const interestedInMap = Shark.get("interestedInMap");
			this.__interestSolutionsLabel = this.extraData.interestSolutions.map(item => interestedInMap[item]).join(", ");
		}
	}

	isValid() {
		this.validate();

		return this.__isValid;
	}

	onDataChanged(data) {
		switch (data.property) {
			case "__followUpList":
				this.__hasFollowUp = this.__followUpList.length > 0;
				this.__followUpCount = this.__followUpList.length;
				break;
			case "constructionSiteData.useRegisteredOffice":
				Shark.render();
				break;
			// Dave: Questa cosa non dovrebbe più servire visto che gestiamo activityStatus a monte.
			// case "extraData.activityStatusId":
			// 	switch (this.extraData.activityStatusId) {
			// 		case 1:
			// 			this.extraData.activityStatus = "In attesa";
			// 			break;
			// 		case 2:
			// 			this.extraData.activityStatus = "Compilata scheda informativa";
			// 			this.__renderActivityStatusAsLink = true;
			// 			break;
			// 	}
			// 	break;
			case "outcome": {
				this.__showFutureContactDate = false;
				this.__showNotInterestedReasonBox = false;
				const visitOutcomeMap = Shark.get("visitOutcomeMap");

				switch (this.outcome) {
					case "1":
						this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Positivo effettuata visita";
						break;
					case "future_v":
						this.__outcomeLabel = visitOutcomeMap[this.outcome];//"dddPositivo visitare in futuro";
						this.__showFutureContactDate = true;
						break;
					case "future_p":
						this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Richiamare in futuro";
						this.__showFutureContactDate = true;
						break;
					case "5":
						this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Non interessato";
						this.__showNotInterestedReasonBox = true;
						break;
					case "6":
						this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Non raggiungibile";
						break;
				}

				this.set("extraData.activityStatusId", 1);

				break;
			}
			case "province":
			case "constructionSiteData.province": {
				this[data.property] = data.newValue.toUpperCase();
				const regionProperty = data.property.replace("province", "region");
				const regionField = document.querySelector(`input[data-sh-prop="${regionProperty}"]`);
				const region = provinceList.filter(item => item.plate === this[data.property]);

				if (region.length === 1) {
					this[regionProperty] = region[0].region;

					if (regionField) {
						regionField.value = this[regionProperty];
					}
				}
				break;
			}
			case "__referenceDate":
			case "__futureContactDate":
				this[data.property.substr(2)] = moment(data.newValue);
				this[data.property + "Label"] = this[data.property.substr(2)].format("DD/MM/YYYY");
				break;
		}
	}

	onOutcomeChanged () {
		this.__showFutureContactDate = false;
		// this.__showNotInterestedReasonBox = false;
		const visitOutcomeMap = Shark.get("visitOutcomeMap");
		// Dave. DUPLICATO!!!
		switch (this.outcome) {
			case "1":
				this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Positivo effettuata visita";
				// this.__showNotInterestedReasonBox = true;
				break;
			case "future_v":
				this.__outcomeLabel = visitOutcomeMap[this.outcome];//"dddPositivo visitare in futuro";
				this.__showFutureContactDate = true;
				break;
			case "future_p":
				this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Richiamare in futuro";
				this.__showFutureContactDate = true;
				break;
			case "5":
				this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Non interessato";
				// this.__showNotInterestedReasonBox = true;
				break;
			case "6":
				this.__outcomeLabel = visitOutcomeMap[this.outcome];//"Non raggiungibile";
				break;
		}

		Shark.render();
		// this.set("extraData.activityStatusId", 1);
	}

	parseFollowUps () {
		if (typeof this.latestFollowUp === "string") {// A che serve??
			//this.latestFollowUp = data.latestFollowUp;
			this.__latestFollowUpHtml = this.latestFollowUp.replace(/\n/g, "<br>");
			this.__hasFollowUp = this.latestFollowUp !== "" || this.__followUpList.length > 0;
		}

		// this.newFollowUpCount = this.totalFollowUpCount - this.mineViewedFollowUp;
		this.__hasNewFollowUp = this.newFollowUpCount > 0;
	}
	
	parseNextAppointment () {
		if (this.nextAppointment) {
			const appointment = Utils.parseJSON(this.nextAppointment);
			const appointmentDateImported = this.importDateField("__nextAppointmentDate", appointment[1]);
			// Dave: Serve una mappa global
			const appointmentTypesMap = {
				"client-phone": "Telefonata",
				"client-email": "eMail",
				"client-visit": "Visita",
			};

			this.__nextAppointment = {
				guid: appointment[0],
				ts: appointment[1],
				type: appointment[2],
				tsLabel: appointmentDateImported ? this.__nextAppointmentDate.format("DD/MM/YYYY") : "",
				typeLabel: appointmentTypesMap[appointment[2]],
			};
		}
	}

	validate() {
		const errors = [];
		this.__errors = {};
		this.__errorsCount = 0;

		if (this.contactSource === 0) {
			errors.push("Devi impostare l'origine del contatto.");
			this.__errors.contactSource = true;
			this.__errorsCount++;
		}

		// if (!this.constructionSiteData.useRegisteredOffice && (this.constructionSiteData.address === "" || this.constructionSiteData.name === "")) {
		// 	this.__errors.constructionSiteData = true;
		// 	this.__errorsCount++;
		// }

		if (this.outcome === "") {
			errors.push("Devi impostare l'esito della visita.");
			this.__errors.outcome = true;
			this.__errorsCount++;
		}

		if (this.prospectName === "" && !this.contact) {
			errors.push("Devi indicare il nome del contatto.");
			this.__errors.prospectName = true;
			this.__errorsCount++;
		}

		if (this.prospectSector === "" && !this.contact) {
			errors.push("Devi indicare il settore merceologico del contatto.");
			this.__errors.prospectSector = true;
			this.__errorsCount++;
		}

		if (this.extraData.providedSpecifications && (this.futureContactDate === "" || this.futureContactDate === "0000-00-00 00:00:00" || !this.futureContactDate.isValid())) {
			errors.push("Se imposti la spunta 'Fornito voce di capitolato' devi impostare un esito che preveda un contatto futuro.");
			this.__errors.extraData_providedSpecifications = true;
			this.__errorsCount++;
		}

		if (this.outcome === "5" && this.outcomeNote === "") {
			errors.push("Devi indicare il motivo per cui il Contatto non è interessato.");
			this.__errors.notInterestedReason = true;
			this.__errorsCount++;
		}

		if (this.isFromLead && this.outcome == "1" && this.outcomeNote === "") {
			errors.push("Poiché il contatto è un Lead devi inserire un commento sull'esito della visita.");
			this.__errors.notInterestedReason = true;
			this.__errorsCount++;
		}

		if (this.outcome.slice(0, 6) === "future" && (this.futureContactDate === "" || this.futureContactDate === "0000-00-00 00:00:00" || !this.futureContactDate.isValid())) {
			errors.push("Hai selezionato un esito che prevede un contatto futuro, devi impostare la data.");
			this.__errors.futureContactDate = true;
			this.__errorsCount++;
		}

		if (this.extraData.interestSolutions.length === 0) {
			errors.push("È obbligatorio selezionare una soluzione di interesse.<br><br>Se non hai indicazioni precise puoi selezionare 'Richiesta generica'.");
			this.__errors.extraData_interestSolutions = true;
			this.__errorsCount++;
		}

		// if (this.plate === "") {
		// 	this.__errors.plate = true;
		// 	this.__errorsCount++;
		// }

		this.__isValid = this.__errorsCount + errors.length === 0;

		return errors;
	}
}

Shark.registerModel("Visit", Visit);

export default Visit;